import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CenteredContainerType } from './types';

const sizeMap = {
  [CenteredContainerType.small]: 872,
  [CenteredContainerType.large]: 1440,
};

export default createUseStyles<string, { type: CenteredContainerType }>(
  {
    root: {
      marginInline: 'auto',
      width: ({ type }) => `min(${sizeMap[type]}px, 100%)`,

      '@media screen and (max-width: 768px)': {
        padding: Spacings.s12,
      },
    },
  },
  { name: 'CenteredContainer' },
);
